module.exports = __webpack_public_path__ + "static/QualifiedDevelopers-logo-cb1baf4bbe75de6dd9b278b4e078dece.png";